import { lazyLoad } from 'utils/loadable';

const CompanyListingPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'QuotationsPage', webpackPrefetch: true */ './CompanyListing'
  ),
);

const ContactListingPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'QuotationsPage', webpackPrefetch: true */ './ContactListing'
  ),
);

const CrmContactsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'QuotationsPage', webpackPrefetch: true */ './CrmContacts'
  ),
);

const DealsListingPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'QuotationsPage', webpackPrefetch: true */ './DealsListing'
  ),
);

export const CrmRoutes = [
  {
    component: CompanyListingPage,
    path: '/customer-assist/company',
    title: 'Companies',
    needsAuth: true,
  },
  {
    component: ContactListingPage,
    path: '/customer-assist/contact',
    title: 'Contacts',
    needsAuth: true,
  },
  {
    component: CrmContactsPage,
    path: '/customer-assist/directory',
    title: 'Directory',
    needsAuth: true,
  },
  {
    component: DealsListingPage,
    path: '/customer-assist/deals',
    title: 'Deals',
    needsAuth: true,
  },
];
